// extracted by mini-css-extract-plugin
export default {"loader":"Container_loader__+swMM"};